import * as Yup from 'yup'; 
import { onlyChars, firstLetterCapitalized } from '../../components/form/Helpers/Parsers'
import { isPostalCodeValid } from '../../components/form/Validations/PostalCodeValidation'
import { FieldTypes, IFields, InputModes } from '../../models/form/IFieldsDefinition'
import { FormValidationObject } from '../../models/form/IFormDefinition'

export enum CorrespondenceAddressInfoFieldsNames {
   CorrespondenceStreet = "CorrespondenceStreet",
   CorrespondenceHouseNumber = "CorrespondenceHouseNumber",
   CorrespondenceApartamentNumber = "CorrespondenceApartamentNumber",
   CorrespondencePostalCode = "CorrespondencePostalCode",
   CorrespondenceCity = "CorrespondenceCity",
}

export const correspondenceAddressInfoFields: IFields = {
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceStreet]: {
      order: 0,
      name: CorrespondenceAddressInfoFieldsNames.CorrespondenceStreet,
      type: FieldTypes.string,
      label: "Ulica",
      maxLength: 50,
      editable: true,
      parser: firstLetterCapitalized,
   },
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceHouseNumber]: {
      order: 5,
      name: CorrespondenceAddressInfoFieldsNames.CorrespondenceHouseNumber,
      type:  FieldTypes.string,
      label: "Numer domu",
      maxLength: 7,
      editable: true,
   },
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceApartamentNumber]: {
      order: 10,
      name: CorrespondenceAddressInfoFieldsNames.CorrespondenceApartamentNumber,
      type:  FieldTypes.string,
      label: "Numer mieszkania",
      maxLength: 7,
      editable: true,
   },
   [CorrespondenceAddressInfoFieldsNames.CorrespondencePostalCode]: {
      order: 15,
      name: CorrespondenceAddressInfoFieldsNames.CorrespondencePostalCode,
      type:  FieldTypes.string,
      label: "Kod pocztowy",
      mask: "99-999",
      inputMode: InputModes.numeric,
      editable: true,
   },
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceCity]: {
      order: 20,
      name: CorrespondenceAddressInfoFieldsNames.CorrespondenceCity,
      type:  FieldTypes.string,
      label: "Miejscowość",
      maxLength: 50,
      editable: true,
      parser: onlyChars,
   },
}

export const correspondenceAddressInfoFieldValidations: FormValidationObject<typeof CorrespondenceAddressInfoFieldsNames> = {
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceStreet]: Yup.string().trim().required('Nieprawidłowa wartość').min(2, 'Nieprawidłowa wartość') as Yup.StringSchema<string>,
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceHouseNumber]: Yup.string().trim().required('Nieprawidłowa wartość').max(10, 'Nieprawidłowa wartość') as Yup.StringSchema<string>,
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceApartamentNumber]: undefined,
   [CorrespondenceAddressInfoFieldsNames.CorrespondencePostalCode]: Yup.string().trim().test(isPostalCodeValid) as Yup.StringSchema<string>,
   [CorrespondenceAddressInfoFieldsNames.CorrespondenceCity]: Yup.string().trim().required('Nieprawidłowa wartość') as Yup.StringSchema<string>,
}